var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('warning-page',{attrs:{"primary-text":_vm.primaryText,"secondary-text":_vm.secondaryText,"code-icon":_vm.codeIcon,"action-link":_vm.actionLink}})}
var staticRenderFns = []

export { render, staticRenderFns }